import * as React from 'react';
import classNames from 'classnames';
import { Props as IReactSelectProps } from 'react-select/lib/Select';
import * as moment from 'moment';

import IMPComponent from '../interfaces/IMPComponent';

import Select from '../Select';

const defaultMonths = Array.from(Array(12)).map((_, monthNumber) => monthNumber);

export interface IMonthSelectProps extends IMPComponent, IReactSelectProps {
  selectedMonth?: number;
  months?: number[];
}

const MonthSelect: React.FunctionComponent<IMonthSelectProps> = ({
  className,
  style,
  months,
  selectedMonth,
  ...props
}) => {
  const cn = classNames('MonthPicker', className);
  const currentMonth = isFinite(selectedMonth as number) ? Number(selectedMonth) : moment().month();

  const options = (months as number[]).map(monthNumber => {
    return {
      label: moment()
        .month(monthNumber)
        .format('MMMM'),
      value: String(monthNumber),
    };
  });

  const selectedValue =
    options.find(({ value }) => {
      return Number(value) === currentMonth;
    }) || options[0];

  return (
    <div className={cn} style={style}>
      <Select options={options} isSearchable={false} value={selectedValue} {...props} />
    </div>
  );
};

MonthSelect.defaultProps = {
  months: defaultMonths,
};

export default React.memo(MonthSelect);



// WEBPACK FOOTER //
// ./src/components/MonthSelect/index.tsx